import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { reduxForm, Field, Form } from 'redux-form';
import { Button, HeadingFive, Card } from 'hui/src/styled';
import { fillContainer, buttonAlignment, disabledButton } from './shared/SharedStyles';
import { EventCategories, EventActions } from '../../../constants/Analytics';
import TextArea from '../CustomQuestions/TextArea';

const validate = values => {
  const errors = {};
  if (!values.job_description) {
    errors.job_description = `Please specify what's involved in this job`;
  }
  return errors;
};

const DescriptionStep = ({ onSubmit, invalid, category }) => (
  <Form onSubmit={onSubmit} style={fillContainer}>
    <Card m={0} p={1} center style={fillContainer}>
      <HeadingFive>Any additional details?</HeadingFive>
      <Field
        name="job_description"
        component={TextArea}
        rows={10}
        placeholder={`Please provide as much detail as possible`}
      />
      <Button
        disabled={!!invalid}
        type={'submit'}
        m={0.5}
        block
        style={!invalid ? buttonAlignment : disabledButton}
        data-ga-interactive={false}
        data-ga-category={EventCategories.POST_JOB_MODAL}
        data-ga-action={EventActions.PRESS_NEXT_DESCRIPTION_SCREEN}
        data-ga-label={category}
      >
        Next
      </Button>
    </Card>
  </Form>
);

DescriptionStep.propTypes = {
  question: PropTypes.object,
  onSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  category: PropTypes.string
};

const ConnectedStep = reduxForm({
  form: 'GQWIZARD',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(DescriptionStep);

export default connect()(ConnectedStep);
